export default {
  decorate(app, key) {
    return app;
  },
};
